module.exports = __webpack_public_path__ + "static/how_we_do_it-ab27256c4d7a85168edcff6520fac7d9.png";